import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'

export default function KelolaGradeEdit() {
  /* ========================================== Helpers ========================================= */
  const history = useHistory()
  const { id }  = useParams()

  /* ====================================== Consume Context ===================================== */
  const { getRequest, putRequest } = useBaseContext()

  /* ======================================= Local States ======================================= */
  const [grade, setGrade]           = useState('')
  const [persentasi, setPersentasi] = useState(0)
  const [status, setStatus]         = useState(1)
  const [tipePenilaian, setTipePenilaian]   = useState('')

  /* ========================================= Functions ======================================== */
  async function getData() {
    let response = await getRequest('type-score-id?id=' + id)
    if (response.data) {
      var data = response.data
      setTipePenilaian(data.type_score_type)
      setGrade(data.type_score)
      setPersentasi(data.percentage)
      setStatus(data.active ? 1 : 0)
    }
  }

  /* ========================================= Functions ======================================== */
  async function onSubmitForm() {
    if (
      grade != '' &&
      persentasi != '' &&
      status != '' &&
      tipePenilaian != '' &&
      /^[0-9]+$/.test(persentasi)
    ) {
      let form = new FormData()
      form.append('type_score', grade)
      form.append('type_score_type', tipePenilaian)
      form.append('active', status)
      form.append('percentage', persentasi)
      form.append('id', id)
      let response = await putRequest('type-score', form)
      if (response) {
        window.notification(200, 'Data grade berhasil diubah', 'success')
        history.goBack()
      }
    } else {
      window.notification(400, 'Harap isi semua form', 'error')
    }
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getData()
  }, [])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header
          pageName="Edit Grade"
          linkName="Edit"
          links={[{ url: '/kelola-grade', name: 'Kelola Grade' }]}
        />

        <div className="row">
          {/* [ Form Validation ] start */}
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>Edit Grade</h5>
              </div>
              <div className="card-body">
                <form>
                  <div className="form-group">
                    <label className="form-label">Grade</label>
                    <input
                      type="text"
                      value={grade}
                      onChange={(e) => setGrade(e.target.value)}
                      className="form-control col-md-4"
                      name="role"
                      placeholder="Nama Grade"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Persentasi</label>
                    <input
                      type="number"
                      maxLength={2}
                      value={persentasi}
                      onChange={(e) => setPersentasi(e.target.value)}
                      className="form-control col-md-4"
                      name="role"
                      placeholder="Persentasi"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Tipe Penilaian</label>
                    <select
                      className="form-control col-md-4"
                      value={tipePenilaian}
                      onChange={(e) => setTipePenilaian(e.target.value)}
                      name=""
                    >
                      <option>Pilih Tipe Penilaian</option>
                      <option value={'harian'}>Harian</option>
                      <option value={'ujian_tulis'}>Ujian Tulis</option>
                      <option value={'ujian_praktik'}>Ujian Praktik</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label className="form-label">Status</label>
                    <select
                      className="form-control col-md-4"
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      name=""
                    >
                      <option value={1}>Aktif</option>
                      <option value={0}>Tidak Aktif</option>
                    </select>
                  </div>
                  <button
                    type="button"
                    onClick={(e) => {
                      history.goBack()
                    }}
                    className="btn btn-outline-danger mr-2"
                  >
                    Kembali
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    onClick={(e) => {
                      e.preventDefault()
                      onSubmitForm()
                    }}
                    className="btn  btn-primary"
                  >
                    Simpan
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </TemplateAdmin>
  )
}
